// extracted by mini-css-extract-plugin
export default {"formHeading":"vL-z","form":"wL-z","submitBtn":"xL-z","disabled":"yL-z","input":"zL-z","error":"AL-z","submitMsg":"BL-z","signIn":"CL-z"};